import dayjs, { Dayjs } from "utils/dayjs"

import { Guid, IApiLink } from "@/types"
import { ApiLinkEntity, ApiLinkRel, Purpose } from "config/constants"
import InvoiceDraftAsset, { IGetInvoiceDraftAssetDto } from "./InvoiceDraftAsset"
import CustomerExtended, { ICustomerExtendedDto } from "./CustomerExtended"
import DowntimePeriod, { IGetDowntimePeriodDto } from "./DowntimePeriod"
import { IInvoicePositionUnitPrice } from "./InvoicePositionBase"

export interface IGetAdHocOutgoingInvoiceDraftDto {
    reservationId: Guid
    number: string
    purpose: string
    start: string
    end?: string | null
    articleId: Guid
    customer: ICustomerExtendedDto
    assets?: IGetInvoiceDraftAssetDto[] | null
    downtimePeriods?: Pick<IGetDowntimePeriodDto, "description" | "start" | "end" | "discount">[] | null
    downtimeDays?: number | null
    costUnit?: string | null
    links: IApiLink[]
}

interface ICreateAdHocOutgoingInvoiceDraftInvoicePositionDto extends IInvoicePositionUnitPrice {
    number: string
    text?: string | null
}

export interface ICreateAdHocOutgoingInvoiceDraftDto {
    reservationId: Guid
    invoiceHeaderText?: string | null
    invoiceFooterText?: string | null
    invoicePositions: ICreateAdHocOutgoingInvoiceDraftInvoicePositionDto[]
    customerNumber: string
    overrideOnlyMachinesWarning?: boolean
    sendToErp?: boolean
}

export default class AdHocOutgoingInvoiceDraft {
    reservationId: Guid
    number: string
    purpose: Purpose
    start: Dayjs
    end?: Dayjs
    articleId: Guid
    customer: CustomerExtended
    assets: InvoiceDraftAsset[]
    downtimePeriods: DowntimePeriod[]
    downtimeDays: number
    costUnit?: string
    linkCreateAdHocOutgoingInvoice?: IApiLink

    constructor(dto: IGetAdHocOutgoingInvoiceDraftDto) {
        this.reservationId = dto.reservationId
        this.number = dto.number
        this.purpose = dto.purpose as Purpose
        this.start = dayjs.utc(dto.start, "YYYY-MM-DD") // take only date ignoring the time
        this.end = dto.end ? dayjs.utc(dto.end, "YYYY-MM-DD") : undefined // take only date ignoring the time
        this.articleId = dto.articleId
        this.customer = new CustomerExtended(dto.customer)
        this.assets = dto.assets?.map(invoiceDraftAssetDto => new InvoiceDraftAsset(invoiceDraftAssetDto)) || []
        this.downtimePeriods = dto.downtimePeriods?.map(downtimePeriodDto => new DowntimePeriod({
            ...downtimePeriodDto,
            id: ""
        })) || []
        this.downtimeDays = dto.downtimeDays ?? 0
        this.costUnit = dto.costUnit ?? undefined
        this.linkCreateAdHocOutgoingInvoice = dto.links.find(link => link.entity === ApiLinkEntity.adHocInvoice && link.rel === ApiLinkRel.new)
    }

    get invoicePeriodTotalDays() {
        return this.end ? this.end.diff(this.start, "days") + 1 : 0
    }
}
